import * as TemplateList from '../templates';

class SimpleRenderHelper {

	constructor( templates ) {
		this.templates = templates;
	}

	addTemplate( name, callback ) {
		this.templates[ name ] = callback;
	}

	async render( name, data ) {
		return this.#renderTemplate( name, data );
	}

	#renderTemplate( name, data ) {
		return this.templates[ name ]( {
			...data,
			render: ( innerTemplate, innerData ) => this.#renderTemplate( innerTemplate, innerData ),
		} );
	}
}

class WorkerRenderHelper extends SimpleRenderHelper {

	static fakeId = 0;

	constructor( templates ) {
		super( templates )
		this.messages = {};
		this.worker = new Worker( new URL( /* webpackChunkName: 'render-worker' */ '../render-worker.js', import.meta.url ) );
		this.worker.onmessage = ( ev ) => this.#onmessage( ev );
		this.worker.onerror = ( ...args ) => console.error( ...args );
	}
	#onmessage = ( ev ) => {
		const {id, response} = ev.data;
		if ( this.messages[id] ) {
			this.messages[id].call( this, response );
			delete this.messages[id];
		}
	}

	#postMessage( action, payload ) {
		const id = WorkerRenderHelper.fakeId++;
		return new Promise( resolve => {
			this.worker.postMessage( {id, action, payload: payload} );
			this.messages[id] = ( response ) => resolve( response );
		} )
	}

	addTemplate( name, renderCallback ) {
		return super.addTemplate( name, renderCallback );
		//return this.#postMessage( 'addTemplate', { name, renderCallback } );
	}


	async render( name, data ) {
		if ( name in TemplateList ) {
			return this.#postMessage( 'render', { name, data } );
		}
		return super.render( name, data );
	}
}

export default ( () => {
	const workerEnabled = false;
	if ( ( 'Worker' in window ) && workerEnabled ) {
		return new WorkerRenderHelper( Object.fromEntries( Object.entries( TemplateList ) ) );
	} else {
		return new SimpleRenderHelper( Object.fromEntries( Object.entries( TemplateList ) ) );
	}
} )()
